import type { Tile } from "../engine";
import {
  resolveSeaShoreEdgeLayerNames,
  resolveSeaShoreInnerCornerLayerNames,
} from "./seaShoreConnectivity";
import { resolveSeaShoreOuterCornerLayerNames } from "./seaShoreCornerConnectivity";
import { SEA_SHORE_LAYER_NAMES } from "./seaShoreLayers.generated";

function bakedSeaShoreOverlayLayerNames(layerNames: readonly string[]): string[] {
  return layerNames.filter((layerName) =>
    (SEA_SHORE_LAYER_NAMES as readonly string[]).includes(layerName),
  );
}

function resolveSeaShoreOverlayLayerNames({
  tiles,
  width,
  x,
  y,
}: {
  tiles: readonly Tile[];
  width: number;
  x: number;
  y: number;
}): string[] {
  return [
    ...resolveSeaShoreEdgeLayerNames({ tiles, width, x, y }),
    ...resolveSeaShoreInnerCornerLayerNames({ tiles, width, x, y }),
    ...resolveSeaShoreOuterCornerLayerNames({ tiles, width, x, y }),
  ];
}

export function resolveBakedSeaShoreOverlayLayerNames({
  tiles,
  width,
  x,
  y,
}: {
  tiles: readonly Tile[];
  width: number;
  x: number;
  y: number;
}): string[] {
  return bakedSeaShoreOverlayLayerNames(resolveSeaShoreOverlayLayerNames({ tiles, width, x, y }));
}
